import { computed } from 'vue';

// 共用的排序項目邏輯
export function useSortableItem(props, emit) {
  // 格式化日期
  const formatDate = (date) => {
    return new Date(date).toLocaleString('en-US', {
      year: 'numeric', 
      month: '2-digit', 
      day: '2-digit', 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  // 格式化價格
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', { 
      style: 'currency', 
      currency: 'USD' 
    }).format(amount);
  };

  // 移動事件處理
  const handleMoveToTop = () => {
    emit('moveToTop', props.item.id);
  };

  const handleMoveToBottom = () => {
    emit('moveToBottom', props.item.id);
  };

  const handleTogglePin = () => {
    emit('moveToPin', props.item.id);
  };

  // Pin 圖標
  const pinIconSrc = computed(() => 
    props.isPinned 
      ? require('../../images/icons/icon_star_yellow.svg')
      : require('../../images/icons/icon_star_yellow_empty.svg')
  );

  // 顯示拖拽圖標
  const showSortableIcon = computed(() => 
    props.orderType === 'custom_order' && props.isSortable && !props.selectable
  );

  return {
    formatDate,
    formatCurrency,
    handleMoveToTop,
    handleMoveToBottom,
    handleTogglePin,
    pinIconSrc,
    showSortableIcon
  };
}

export function useActionButtons(props) {
  const showMoveButtons = computed(() => props.orderType === 'custom_order');
  
  return {
    showMoveButtons
  };
}